<template>
	<v-row class="py-3" align="center">
		<v-col align="center" cols="12" lg="4" md="4" sm="6">
			<img
				:style="inlineStyles.characterGlow"
				:src="require('@/assets/images/'+characterPosition+'.webp')"
				alt="Javier Correa Pose"
				width="84%"
			/>
		</v-col>

		<v-col
			:align="mdBreakpoint ? 'center' : 'start'"
			cols="12" lg="8" md="8" sm="6"
		>
			<v-container :class="xsBreakpoint ? 'container-margin' : ''">
				<!-- Title -->
				<h1>
					<span :style="inlineStyles.greetingText">
						Hello!
					</span>
					I'm Javier Correa.
				</h1>

				<!-- Description -->
				<h4
					:class="mdBreakpoint ? 'mb-3' : ''"
					v-for="sentence in descriptionSentences"
					:key="sentence"
				>
					{{ sentence }}
				</h4>

				<!-- Buttons -->
				<v-row
					align="center"
					:justify="mdBreakpoint ? 'center' : 'start'"
					no-gutters
				>
					<!-- CV Button -->
					<v-col cols="auto">
						<v-btn
							:class="mdBreakpoint ? 'mb-3' : 'mr-2'"
							@click="goToCurriculumRoute()"
							:color="inlineStyles.colors.secondary"
							outlined
						>
							Check my CV
						</v-btn>
					</v-col>

					<v-col cols="auto">
						<!-- Social Networks Buttons with Tooltip -->
						<v-tooltip
							v-for="(socialIcon, index) in socialIcons"
							:key="index"
							content-class="mt-n1 pa-0"
							color="transparent"
							bottom
						>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									:class="mdBreakpoint ? 'mx-3' : 'mx-1'"
									:href="socialIcon.href"
									v-bind="attrs"
									v-on="on"
									target="_blank"
									:color="inlineStyles.colors.secondary"
									outlined
									small
									fab
								>
									<v-icon>mdi-{{socialIcon.icon}}</v-icon>
								</v-btn>
							</template>
							<v-layout class="align-center" column>
								<div class="triangle-up"></div>
								<v-card class="px-4 py-1" color="#222" dark flat>
									<span>{{socialIcon.tip}}</span>
								</v-card>
							</v-layout>
						</v-tooltip>
					</v-col>
				</v-row>
			</v-container>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name: 'HomeView',
	props:{
		inlineStyles: {
			type: Object,
			require: true
		},
		windowSize: {
			type: Object,
			required: true
		}
	},
	// Data Ordered Alphabetically
	data: () => ({
		descriptionSentences: [
			"I'm a Software Ingenieur with knowledge in FrontEnd Development, UI and UX.",
			"I also like drawing, illustration, image editing and 3D design and modeling.",
			"In this way, I welcome you to my Web Portfolio, and I hope you find it interesting."
		],
		socialIcons: [
			{href: "", icon: "facebook", tip: "Facebook"},
			{href: "" ,icon: "twitter", tip: "Twitter"},
			{
				href: "https://www.linkedin.com/in/javier-correa-cepeda-a071aa149/",
				icon: "linkedin",
				tip: "Linkedin"
			},
			{
				href: "https://github.com/JavierCorreaC",
				icon: "github",
				tip: "Github"
			},
			{
				href:"https://sketchfab.com/AnotherFiction",
				icon: "cube-outline",
				tip: "Sketchfab"
			}
		]
	}),
	computed: {
		characterPosition() {
			return( this.windowSize.width < 600 ? "front" : "left" )
		},
		mdBreakpoint() {
			return( this.windowSize.width < 855 ? true : false )
		},
		xsBreakpoint() {
			return( this.windowSize.width < 600 ? true : false )
		},
	},
	methods: {
		goToCurriculumRoute() {
			this.$router.push({ name: "Curriculum" })
		}
	}
}
</script>

<style scoped>
.container-margin {
	margin-top: -80px;
}
.triangle-up {
	width: 0;
	height: 0;
	border-left: 10px solid transparent;
	border-right: 10px solid transparent;
	border-bottom: 10px solid #222;
}
</style>